import FormValidationStrategy from "../strategy/FormValidationStrategy.js";

export default class PhoneValidationStrategy extends FormValidationStrategy {
  validate(valueString, isRequired) {
    let isValid = false;
    const value = valueString.toString().trim(),
      phoneRegexp = /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){9,14}(\s*)?$/;

    if (isRequired && !value.length) {
      return {
        isValid,
        message: this.loadErrorMessage("empty", "Телефон"),
      };
    } else if (value.length >= 1 && !phoneRegexp.test(value)) {
      return {
        isValid,
        message: this.loadErrorMessage("regexp", "Телефон"),
      };
    }

    isValid = true;

    return {
      isValid,
      message: "",
    };
  }
}
